<template>
    <van-popup
            v-model="repaymentShow"
            position="bottom"
            :style="{ height: 'auto'}"
            @close="repaymentShow = false"
        >
        <van-datetime-picker
                v-model="currentDate"
                type="date"
                :min-date="minDate"
                :max-date="maxDate"
                @cancel="onCancel"
                @confirm="onConfirm"
                :formatter="formatter"

        />
    </van-popup>
</template>

<script>

    import dateFormat from 'dateformat'

    export default {
        data() {
            return {
                flag:false,
                value: this.itemValue,
                repaymentShow:false,
                currentDate:'',
                minDate: new Date(2026,0,1),
                maxDate: new Date(2030,0,1),
            }
        },
        model: {
            prop: 'itemValue',
            event: 'selectterm'
        },
        props: {
            columnsData: {},
            overlay: {
                type: Boolean,
                default: true
            },
            id: String,
            itemValue:{
                type: String,
                default: ''
            }
        },
        watch: {
            term: function (newval) {
                this.value = newval;
            },
            value: function (newval) {
                this.$emit('selectterm',newval);
            }
        },
        mounted () {

        },
        methods: {
            onCancel()
            {
              // alert('取消');
                this.repaymentShow = false;
            },
            onConfirm(value)
            {
                this.value = dateFormat(value,'yyyy-mm-dd');
                this.repaymentShow = false;
            },
            doSelect()
            {
                if( this.itemValue )
                {
                    this.currentDate = this.strToDate(this.itemValue);
                }
                this.repaymentShow = true;
            },
            formatter(type, value) {// 格式化选择器日期
                if (type === "year") {
                    return `${value}年`;
                } else if (type === "month") {
                    return `${value}月`;
                }else if( type =='day')
                {
                    return `${value}日`;
                }
                return value;
            },
            strToDate(str)
            {
                if( str )
                {
                    let arr = str.split('-');
                    return new Date(parseInt(arr[0]),parseInt(arr[1]) - 1,parseInt(arr[2]))
                }

                return new Date();
            }
        },
        computed:{
            dateStr:function()
            {
                return this.itemValue;
            }
        }

    }
</script>

<style scoped>
    /* .city-mask{
        position: fixed;
        top:0;
        bottom: 0;
        right: 0;
        left: 0;
        background-color: rgba(0,0,0,.6);
        z-index: 99;
    } */
</style>